const config = {
  apiurl: "https://faucet-j3sx2ddk4a-ue.a.run.app",
  etherscanroot: "https://testnet-explorer.gochain.io"
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js